import { Component, OnInit, TemplateRef, Input } from "@angular/core";
import { BsModalService } from "ngx-bootstrap/modal";
import { BsModalRef } from "ngx-bootstrap/modal";
import { AuthenticationService } from "../../_services/authentication.service";
import { AlertService } from "../../_services";
import { Router, ActivatedRoute } from "@angular/router";
import { RatingDialogComponent } from "../../rating-dialog/rating-dialog.component";
import { NotificationsService } from "angular2-notifications";
import { PusherService } from "../../_services/pusher.service";
import { CognitoService } from "../../_services/Cognito.service";

@Component({
  selector: "app-dashboard-header",
  templateUrl: "./dashboard-header.component.html",
  styleUrls: ["./dashboard-header.component.css"],
})
export class DashboardHeaderComponent implements OnInit {
  @Input() type: string;
  // @ViewChild(RatingDialogComponent) _RatingDialogComponent : RatingDialogComponent;
  currentUser: any;
  logoimage: any;
  radioimage: any;
  modalRef: BsModalRef;
  payment_recieved_id;
  bidreceived_id;
  currentUserId;
  loading: Boolean = false;
  config = { backdrop: true, ignoreBackdropClick: true, keyboard: false };
  userID: any;
  merchantId: "";
  paypalMerchantId: "";

  public options = {
    position: ["top", "right"],
    lastOnBottom: false,
    preventDuplicates: true,
    timeOut: 3000,
  };
  accessToken: string;

  constructor(
    private modalService: BsModalService,
    private _authenticationService: AuthenticationService,
    private alertService: AlertService,
    private route: ActivatedRoute,
    private router: Router,
    private _service: NotificationsService,
    private pusherService: PusherService,
    private cognitoService: CognitoService,
  ) {
    const userInfo = JSON.parse(localStorage.getItem("currentUser"));
    this.currentUser = userInfo ? userInfo.result : null;
    this.userID = userInfo.result.id;
    // this.currentUserId = this.currentUser.id;

    /*this.pusherService.channel.bind('paymentreceived', data => {
        if (this.currentUserId == data.message.user_id) {
          this.payment_recieved_id = data.message.item[0].id;
          this._service.alert(data.message.message);
        }
      });
      this.pusherService.channel.bind('bidreceived', data => {
        if (this.currentUserId == data.message.user_id) {
          this.bidreceived_id = data.message.item[0].id;
          this._service.alert(data.message.message);
        }
      });*/
    if (this.currentUser != null) {
      this.pusherService.channel.bind("webnotificatn", (data) => {
        if (this.currentUser.id != null || this.currentUser.id != "") {
          if (this.currentUser.id == data.message.user_id) {
            setTimeout(() => {
              this._service.alert(data.message.message);
            }, 5000);
          }
        }
      });
    }
  }

  ngOnInit() {
    this._authenticationService.isLoggedIn();
    this._authenticationService.isSetTokenIn();
    this._authenticationService.isEntryhref();
    this._authenticationService.isCreatePaypalToken();
    this._authenticationService.AddPartnerResponse();
    this.logoimage = "../../assets/images/logo.png";
    this.radioimage = "../../assets/images/radio.png";
    this.route.queryParams.subscribe((res) => {
      localStorage.setItem("queryParams", JSON.stringify(res));
      localStorage.setItem("merchantId", res.merchantId);
      localStorage.setItem("merchantIdInPayPal", res.merchantIdInPayPal);
      if (res.merchantId != null && res.merchantIdInPayPal != null) {
        this.merchantId = res.merchantId;
        this.paypalMerchantId = res.merchantIdInPayPal;
        this.updateClientPaypal(this.merchantId, this.paypalMerchantId);
      }
    });
    /*setTimeout(() => {
        this._service.alert('hello');
      }, 5000);
      
      setTimeout(() => {
        this._service.alert('hello secobnd');
      }, 5000);*/
    if (this.type != "trade") {
      if (this.currentUser.rating_pending === 1) {
        this.modalRef = this.modalService.show(
          RatingDialogComponent,
          this.config
        );
      }
    }
  }

  public updateClientPaypal(merchantId, paypalMerchantId) {
    // var userInfo = JSON.parse(localStorage.getItem("queryParams"));
    // var useridInfo = JSON.parse(localStorage.getItem("userid"));
    this.loading = true;
    // this.user_id = useridInfo.result.id;
    // this.merchant_id = userInfo.result.merchantId;
    // this.merchant_Paypal_id = userInfo.result.merchantIdInPayPal;
    const itemData = {
      user_id: this.userID,
      merchant_id: merchantId,
      partner_referral_id: paypalMerchantId,
    };
    this._authenticationService.updatePaypalCred(itemData).subscribe((res) => {
      if (res.status == 200) {
        setTimeout(() => {
          this.loading = false;
        }, 5000);
        this.alertService.success("Updated Paypal Successfully!");
        // setTimeout(()=>{window.location.reload.bind(window.location)}, 100);
      }
    });
  }

  /**
   * Function to open modal
   * @param template
   */
  openModal(template: TemplateRef<any>) {
    this.modalRef = this.modalService.show(
      template,
      Object.assign({}, { class: "gray modal-md" })
    );
  }

  /**
   * function to Disbale Modal
   * @param event
   */
  _hidemodal(event: any) {
    this.modalRef.hide();
  }
  /**
   * function to logout
   * @param event
   */
  _logoutUser() {
    localStorage.clear();
    this.currentUser = null;
    this.currentUserId = null;
    this._authenticationService.logout();
    setTimeout(() => {
      this.router.navigate(["./login"]);
    }, 1000);
    this.modalRef.hide();
  }

  // logOut() {
  //   this.accessToken = localStorage.getItem("accessToken");
  //   let $this = this;
  //   this.cognitoService.signOut(this.accessToken)
  //     .then(() => {
  //       $this._logoutUser()
  //     });
  // }
}



// WEBPACK FOOTER //
// ./src/app/authorized-data/dashboard-header/dashboard-header.component.ts